import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { fireDB } from "../../funcs/firebase";
import { doc, getDoc, updateDoc, serverTimestamp } from "firebase/firestore";
import { Button, Spin, message, Avatar, Alert, Collapse, Tag, Typography, Space } from "antd";
import { InstagramOutlined, CheckCircleOutlined, UserOutlined, SafetyCertificateOutlined, SafetyOutlined, LockOutlined, StarFilled } from "@ant-design/icons";
import { jwtDecode } from "jwt-decode";
import '../login/main.css';

const { Text } = Typography;

// ========================================
// TICKER DATA - Reviews and Creators (same as login page)
// ========================================

const REVIEWS_DATA = [
    {
        text: "We have moved our business from",
        highlightText: " Manychat to InstantDM. I am getting the same product at one-third of the price",
        fullText: "I was paying to Manychat.",
        author: "Yogendra Nathany - Coach"
    },
    {
        text: "I have to say this is",
        highlightText: "one of the best automation app i have used",
        fullText: "instagram & facebook automation, and best part is the customer service that they provide.",
        author: "DULHAN JEWELS - Brand, Shopify & Retail"
    },
    {
        text: "Absolutely wonderful.",
        highlightText: "The best that I have found. Super helpful and super reasonable pricing",
        fullText: "Will stick around for sure, would highly recommend.",
        author: "Victor Vigil"
    },
    {
        text: "This platform is",
        highlightText: "very good and makes automation easy",
        fullText: "to understand and use.",
        author: "Avinash - Coach"
    },
    {
        text: "It has",
        highlightText: "simplified our communication process. The interface is user-friendly",
        fullText: "and the automation features help us respond faster and stay organized.",
        author: "Skill Radar - Coach"
    },
    {
        text: "I really like instantDM.",
        highlightText: "It has been very helpful and at such a great price.",
        fullText: "I highly recommend it.",
        author: "Mark Lee - Creator, Entrepreneur"
    },
    {
        text: "Very",
        highlightText: "easy to use, lot of great features",
        fullText: "and is very affordable.",
        author: "MENTSMART PRIVATE LIMITED - Business & Store"
    },
];

const CREATORS_DATA = [
    {
        image: "https://framerusercontent.com/images/k0bfRSzEQXeIQZd6I3DNGrepvQ0.jpg",
        name: "@yamahaindonesia",
        niches: ["Brand", "Retail Store"],
        followers: "1.5 Million+"
    },
    {
        image: "https://framerusercontent.com/images/TYactyMkUxAa6akdPDzudte2tSo.png",
        name: "artificialntellligence",
        niches: ["AI", "Community", "Education"],
        followers: "1.5 Million+"
    },
    {
        image: "https://framerusercontent.com/images/V1cGFdx7Nh5RAZoW2ua2BI6lpo4.png",
        name: "Kitchen Stories",
        niches: ["Food & Kitchen", "Community"],
        followers: "300K+"
    },
    {
        image: "https://framerusercontent.com/images/u1TqjUQtTA1JioKdRZ1F8qDg.png",
        name: "HCL GUVI",
        niches: ["Institution", "Career Guidance"],
        followers: "280K+"
    },
    {
        image: "https://framerusercontent.com/images/J4hlheRnQUXnK9mvy5NT9kisiFU.png",
        name: "DEBELLIN | TOP BRAND",
        niches: ["Brand", "Life Style"],
        followers: "260K+"
    },
    {
        image: "https://framerusercontent.com/images/0qrO9deXJDS7wAugY2eIpnxEJwE.png",
        name: "Mridul Madhok",
        niches: ["Influencer", "Youtuber"],
        followers: "3 Million+"
    },
    {
        image: "https://framerusercontent.com/images/DjvLzI1Wb9L9tYqRD0fI2N1FODk.png",
        name: "@jeemboombhaa",
        niches: ["Influencer", "Regional Creator"],
        followers: "2.2 Million+"
    },
    {
        image: "https://framerusercontent.com/images/sD2rjLg5BQwaQHaMzPpoliwDVMo.png",
        name: "@praveendheiveegan",
        niches: ["Influencer", "Regional Creator"],
        followers: "900K+"
    },
    {
        image: "https://framerusercontent.com/images/VFq765JQXZvmiIO589ROgdwS4.png",
        name: "Computer Coach & Excel Expert",
        niches: ["Guru", "Digital Seller"],
        followers: "1.4 Million+"
    },
    {
        image: "https://framerusercontent.com/images/vM4VWtAmiKZgu4geUZCr4czJg4.png",
        name: "hybridfitnessindia",
        niches: ["Trainer", "Fitness"],
        followers: "700K+"
    },
    {
        image: "https://framerusercontent.com/images/gFuFG1Hkmce4wQC9ecPt1iWmQa4.png",
        name: "Dulhan Jewels",
        niches: ["Retail Store", "Shopify"],
        followers: "227K+"
    },
];

export default function CollabInvite() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [inviteData, setInviteData] = useState(null);
    const [error, setError] = useState(null);
    const [user, setUser] = useState(null);
    const [processing, setProcessing] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();

    // Instagram OAuth Params
    let scopes = "business_basic,business_content_publish,business_manage_comments,business_manage_messages";
    let appId = "996086435858506";
    let redirectURL = "https://app.instantdm.com/fb-rdr";
    let authUrl = `https://www.instagram.com/oauth/authorize?client_id=${appId}&redirect_uri=${redirectURL}&response_type=code&scope=${scopes}`;

    useEffect(() => {
        const token = localStorage.getItem("token");
        if (token) {
            try {
                const decoded = jwtDecode(token);
                setUser(decoded);
            } catch (error) {
                console.error("Error decoding token:", error);
            }
        }

        const fetchInvite = async () => {
            try {
                const docRef = doc(fireDB, "collab_invitations", id);
                const docSnap = await getDoc(docRef);

                if (docSnap.exists()) {
                    setInviteData({ id: docSnap.id, ...docSnap.data() });
                } else {
                    setError("Invitation not found or expired.");
                }
            } catch (err) {
                console.error("Error fetching invite:", err);
                setError("Failed to load invitation.");
            } finally {
                setLoading(false);
            }
        };

        if (id) fetchInvite();
    }, [id]);

    const handleLogin = () => {
        // Clear localStorage to logout user first
        localStorage.clear();
        // Store the pending invite ID so we can show the popup after login
        localStorage.setItem("pending_collab_invite_id", id);
        window.location.href = authUrl;
    };

    if (loading) {
        return (
            <div className="auth-page" style={{ justifyContent: 'center', alignItems: 'center' }}>
                <Spin size="large" tip="Loading invitation..." />
            </div>
        );
    }

    if (error) {
        return (
            <div className="auth-page" style={{ justifyContent: 'center', alignItems: 'center' }}>
                <div className="auth-card" style={{ textAlign: 'center', maxWidth: 400 }}>
                    <div style={{ fontSize: 48, marginBottom: 16 }}>⚠️</div>
                    <h2 style={{ margin: '0 0 8px 0', color: 'var(--auth-text)' }}>Invitation Error</h2>
                    <p style={{ color: 'var(--auth-text-muted)', marginBottom: 24 }}>{error}</p>
                    <Button type="primary" onClick={() => navigate("/")} style={{ background: 'var(--auth-primary)' }}>Go Home</Button>
                </div>
            </div>
        );
    }

    const { sender, post, owner_username, status } = inviteData;
    const isOwner = user?.default_page?.username === owner_username || user?.username === owner_username;

    return (
        <div className="auth-page">
            {contextHolder}

            {/* Left Side - Branding Panel */}
            <div className="auth-branding" style={{ paddingTop: 20, justifyContent: 'flex-start' }}>
                {/* Floating Keywords */}
                <div className="floating-keywords">
                    <span className="floating-keyword" style={{ top: '12%', left: '8%', animationDelay: '0s' }}>Comment PP</span>
                    <span className="floating-keyword" style={{ top: '25%', right: '10%', animationDelay: '0.5s' }}>Comment Link</span>
                    <span className="floating-keyword" style={{ top: '45%', left: '5%', animationDelay: '1s' }}>Comment Price</span>
                    <span className="floating-keyword" style={{ bottom: '35%', right: '8%', animationDelay: '1.5s' }}>Comment Address</span>
                    <span className="floating-keyword" style={{ bottom: '20%', left: '12%', animationDelay: '2s' }}>Comment Location</span>
                    <span className="floating-keyword" style={{ top: '15%', right: '25%', animationDelay: '2.5s' }}>Comment PDF</span>
                    <span className="floating-keyword" style={{ bottom: '45%', left: '15%', animationDelay: '3s' }}>Comment Guide</span>
                    <span className="floating-keyword" style={{ bottom: '12%', right: '20%', animationDelay: '3.5s' }}>Comment AI</span>
                </div>

                <div className="branding-content">
                    <img
                        src="/logo192.png"
                        alt="InstantDM Logo"
                        className="branding-logo"
                    />
                    <h1 className="branding-title">
                        Collaboration Request
                    </h1>
                    <p className="branding-subtitle">
                        Join thousands of creators using InstantDM to automate Instagram & Facebook DMs. Secure, trusted, and Meta-approved.
                    </p>

                    {/* Video Preview */}
                    {/* <div style={{ marginBottom: 24, borderRadius: 'var(--radius-lg)', overflow: 'hidden', maxWidth: 480, boxShadow: '0 8px 32px rgba(0,0,0,0.12)' }}>
                        <iframe
                            width="100%"
                            height="270"
                            src="https://www.youtube.com/embed/dQw4w9WgXcQ?si=DemoVideoID"
                            title="How InstantDM Works"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            style={{ borderRadius: 'var(--radius-lg)', display: 'block' }}
                        ></iframe>
                    </div> */}

                    {/* Reviews Ticker */}
                    <div className="ticker-section">
                        <div className="ticker-container reviews-ticker">
                            <div className="ticker-track">
                                {[...Array(2)].map((_, setIndex) => (
                                    <div className="ticker-content" key={setIndex}>
                                        {REVIEWS_DATA.map((review, index) => (
                                            <div className="review-card" key={index}>
                                                <div className="review-stars">
                                                    <StarFilled /><StarFilled /><StarFilled /><StarFilled /><StarFilled />
                                                </div>
                                                <p className="review-text">
                                                    "{review.text}{review.text ? ' ' : ''}<span className="highlight">{review.highlightText}</span> {review.fullText}"
                                                </p>
                                                <span className="review-author">— {review.author}</span>
                                            </div>
                                        ))}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Creators Ticker */}
                    <div className="ticker-section creators-section">
                        <div className="ticker-container creators-ticker">
                            <div className="ticker-track ticker-reverse">
                                {[...Array(2)].map((_, setIndex) => (
                                    <div className="ticker-content" key={setIndex}>
                                        {CREATORS_DATA.map((creator, index) => (
                                            <div className="creator-card" key={index}>
                                                <div className="creator-image">
                                                    <img src={creator.image} alt={creator.name} />
                                                </div>
                                                <div className="creator-info">
                                                    <span className="creator-name">{creator.name}</span>
                                                    <div className="creator-niches">
                                                        {creator.niches.map((niche, nIndex) => (
                                                            <span className="niche-tag" key={nIndex}>{niche}</span>
                                                        ))}
                                                    </div>
                                                    <span className="creator-followers">{creator.followers} followers</span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Right Side - Invite Card */}
            <div className="auth-form-panel">
                <div className="auth-card">
                    {/* Header */}
                    <div className="auth-header">
                        {/* <Avatar
                            src={sender?.picture}
                            icon={<UserOutlined />}
                            size={64}
                            style={{ border: '3px solid var(--auth-primary)', marginBottom: 16 }}
                        /> */}
                        <h2>@{sender?.username || "Someone"} requested access</h2>
                        <p>Manage automation for a collab post</p>
                    </div>

                    {/* Trust Badge */}
                    <div style={{
                        background: 'linear-gradient(135deg, rgba(16, 185, 129, 0.08) 0%, rgba(16, 185, 129, 0.04) 100%)',
                        border: '1px solid rgba(16, 185, 129, 0.2)',
                        padding: '12px 16px',
                        borderRadius: 'var(--radius-md)',
                        marginBottom: 20
                    }}>
                        <p style={{ margin: 0, color: '#059669', fontSize: '13px', display: 'flex', alignItems: 'center', gap: 8 }}>
                            <SafetyCertificateOutlined />
                            <span><b>@{sender?.username || "The Sender"}</b> trusts InstantDM</span>
                        </p>
                        <p style={{ margin: '4px 0 0 0', color: 'var(--auth-text-muted)', fontSize: '12px', marginLeft: 22 }}>
                            Official Meta APIs ensure 100% account safety.
                        </p>
                    </div>

                    {/* Post Preview */}
                    {post && (
                        <div style={{
                            background: 'var(--auth-bg)',
                            borderRadius: 'var(--radius-md)',
                            padding: 12,
                            marginBottom: 20,
                            border: '1px solid var(--auth-border)'
                        }}>
                            <div style={{ display: 'flex', gap: 12 }}>
                                <img
                                    src={post.image}
                                    alt="Post"
                                    style={{ width: 70, height: 70, objectFit: 'cover', borderRadius: 'var(--radius-sm)', flexShrink: 0 }}
                                />
                                <div style={{ overflow: 'hidden', flex: 1 }}>
                                    <p style={{ margin: 0, fontWeight: 600, fontSize: 14, color: 'var(--auth-text)' }}>@{post.username}</p>
                                    <p style={{
                                        margin: '4px 0 0 0',
                                        color: 'var(--auth-text-muted)',
                                        fontSize: 12,
                                        display: '-webkit-box',
                                        WebkitLineClamp: 2,
                                        WebkitBoxOrient: 'vertical',
                                        overflow: 'hidden'
                                    }}>
                                        {post.caption || "No caption"}
                                    </p>
                                </div>
                            </div>
                        </div>
                    )}



                    {/* Action Buttons */}
                    {status === 'accepted' ? (
                        <Alert
                            message="Invitation Accepted"
                            description="You have successfully approved access for this post."
                            type="success"
                            showIcon
                            style={{ textAlign: 'left', borderRadius: 'var(--radius-md)' }}
                            action={
                                <Button size="small" type="text" onClick={() => navigate("/dashboard")}>
                                    Go to Dashboard
                                </Button>
                            }
                        />
                    ) : (
                        <>
                            {!user ? (
                                <div>
                                    <Alert
                                        message="Authentication Required"
                                        description={`Please login as @${owner_username} to approve access.`}
                                        type="info"
                                        showIcon
                                        style={{ marginBottom: 16, textAlign: 'left', borderRadius: 'var(--radius-md)' }}
                                    />
                                    <Button
                                        className="social-login-btn instagram"
                                        onClick={handleLogin}
                                        icon={<InstagramOutlined />}
                                        size='large'
                                    >
                                        Continue With Instagram
                                    </Button>
                                    <p className="secure-login-note">
                                        <LockOutlined /> Secured login using official Instagram API
                                    </p>
                                </div>
                            ) : (
                                <div>
                                    <div style={{
                                        marginBottom: 16,
                                        textAlign: 'center',
                                        background: 'var(--auth-bg)',
                                        padding: '10px 14px',
                                        borderRadius: 'var(--radius-md)',
                                        border: '1px solid var(--auth-border)',
                                        fontSize: 14
                                    }}>
                                        Logged in as <b style={{ color: 'var(--auth-primary)' }}>@{user?.default_page?.username || user?.username}</b>
                                    </div>

                                    {isOwner ? (
                                        <Button
                                            type="primary"
                                            block
                                            size="large"
                                            className="auth-submit-btn"
                                            onClick={() => {
                                                window.location.href = `/manage-post/${post.id}?invite_id=${id}&action=review`;
                                            }}
                                            loading={processing}
                                            icon={<CheckCircleOutlined />}
                                        >
                                            Review Request
                                        </Button>
                                    ) : (
                                        <div>
                                            <Alert
                                                message="Account Mismatch"
                                                description={`You are logged in as @${user?.default_page?.username || user?.username}, but this invite is for @${owner_username}.`}
                                                type="warning"
                                                showIcon
                                                style={{ marginBottom: 16, textAlign: 'left', borderRadius: 'var(--radius-md)' }}
                                            />
                                            <Button
                                                danger
                                                block
                                                size="large"
                                                onClick={() => {
                                                    localStorage.clear();
                                                    window.location.reload();
                                                }}
                                                style={{ borderRadius: 'var(--radius-md)', height: 46 }}
                                            >
                                                Logout & Switch Account
                                            </Button>
                                        </div>
                                    )}
                                </div>
                            )}
                        </>
                    )}

                    {/* Footer */}
                    <div className="auth-footer">
                        <Button
                            className="auth-help-btn"
                            target="_blank"
                            href='https://instagram.com/instant.dm'
                        >
                            Need Help? Contact us - Quick Support
                        </Button>
                    </div>

                    {/* Trust Badges */}
                    <div className="trust-badges auth-trust-badges">
                        <img
                            src="https://framerusercontent.com/images/c0o1mNbHLKhdEqHalSsh1qOJ8.webp?width=50&height=50"
                            alt="Meta Partner"
                            className="trust-badge"
                        />
                        <img
                            src="https://framerusercontent.com/images/MabHaaNcQ4teDx1Kd9uNrQUL1c.png?scale-down-to=512&width=558&height=125"
                            alt="Instagram Partner"
                            className="trust-badge"
                        />
                        <img
                            src="https://framerusercontent.com/images/OsRHaZK5SG3gj7UNjoPBIQQCw.svg?width=133&height=45"
                            alt="App Store Partner"
                            className="trust-badge"
                        />
                        <img
                            src="https://framerusercontent.com/images/BserlDMbsbbZLyzPNawjFV9MtY.svg?width=150&height=45"
                            alt="Play Store Partner"
                            className="trust-badge"
                        />
                    </div>
                </div>

                {/* FAQs Section - Below Card */}
                <Space direction="vertical" align="center" style={{ marginTop: 24, width: '100%', maxWidth: 400 }}>
                    {/* Account Safety FAQs */}
                    <div style={{
                        width: '100%',
                        background: 'var(--auth-card-bg)',
                        borderRadius: 'var(--radius-lg)',
                        border: '1px solid var(--auth-border)',
                        overflow: 'hidden'
                    }}>
                        <div style={{
                            padding: '12px 16px',
                            borderBottom: '1px solid var(--auth-border)',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 8
                        }}>
                            <SafetyOutlined style={{ color: 'var(--auth-success)' }} />
                            <span style={{ fontWeight: 600, fontSize: 14, color: 'var(--auth-text)' }}>Account Safety & FAQs</span>
                        </div>
                        <Collapse ghost accordion size="small">
                            <Collapse.Panel header="What is InstantDM?" key="0">
                                <p style={{ fontSize: 13, color: 'var(--auth-text-muted)', margin: 0 }}>InstantDM is a simplified, powerful alternative to tools like ManyChat. We help creators automate their Instagram DMs and comments to grow their business.</p>
                            </Collapse.Panel>
                            <Collapse.Panel header="Is my account safe?" key="1">
                                <p style={{ fontSize: 13, color: 'var(--auth-text-muted)', margin: 0 }}>Yes, InstantDM is 100% safe. We are an official Meta Tech Partner and use approved APIs. We never ask for your password.</p>
                            </Collapse.Panel>
                            <Collapse.Panel header="What permissions do I need to give?" key="2">
                                <p style={{ fontSize: 13, color: 'var(--auth-text-muted)', margin: 0 }}>The brand can never see conversations between you and your audience. You can limit permissions and revoke access at any time.</p>
                            </Collapse.Panel>
                            <Collapse.Panel header="Can I revoke access later?" key="3">
                                <p style={{ fontSize: 13, color: 'var(--auth-text-muted)', margin: 0 }}>Absolutely. You can revoke InstantDM's access at any time from your Facebook or Instagram Business Integration settings.</p>
                            </Collapse.Panel>
                            <Collapse.Panel header="Will it stop other automation in different tools?" key="4">
                                <p style={{ fontSize: 13, color: 'var(--auth-text-muted)', margin: 0 }}>No, it won't stop or interfere with any other automation tools you may be using. InstantDM works independently alongside your existing setup.</p>
                            </Collapse.Panel>
                        </Collapse>
                    </div>

                    <div style={{ marginTop: 16, color: 'var(--auth-text-light)', fontSize: 11, textAlign: 'center' }}>
                        <p style={{ margin: 0 }}>Protected by SSL. 256-bit Encryption.</p>
                        © {new Date().getFullYear()} InstantDM. All rights reserved.
                    </div>
                </Space>
            </div>
        </div>
    );
}
